
/* 合法uri */
export function validateURL (textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validatAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/* QQ */
export function validatQQ (str) {
  const reg = /^[1-9][0-9]{4,14}$/
  return reg.test(str)
}

/* 微信号 */
export function validatWx (str) {
  const reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/
  return reg.test(str)
}

/* 正整数 */
export function validatZnum (str) {
  const reg = /^[1-9]+[0-9]*$/
  return reg.test(str)
}

/* email */
export function validatEmail (str) {
  const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
  return reg.test(str)
}

/**
 * 校验银行卡号
 * @param {卡号} str
 * @returns
 */
export function validatBankCard (str) {
  const reg = /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/
  return reg.test(str)
}

/**
 * 校验中文姓名
*/
export function validatRealname (str) {
  const reg = /^[\u4e00-\u9fa5]{1,6}(·[\u4e00-\u9fa5]{1,6}){0,2}$/
  return reg.test(str)
}

export function validataIdcard (code) {
  code = code.toUpperCase()
  // 前2位城市码
  let city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外 ' }
  // 加权因子
  let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  // 校验位
  let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
  // 身份证简单正则
  let Reg = /^\d{6}(18|19|20)?\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  // 身份证号码数组
  let arrCode = code.split('')

  // 校验编码为空，简单正则，城市编码
  if (!code || !Reg.test(code) || !city[code.substr(0, 2)] || code.length !== 18) { return false }

  // 校验18位身份证需要验证最后一位校验位
  // ∑(ai×Wi)(mod 11)
  let sum = 0
  for (let i = 0; i < 17; i++) { sum += arrCode[i] * factor[i] }
  if (parity[sum % 11] !== arrCode[17]) { return false }

  return true
}
/**
 * 判断是否为空
 */
export function validatenull (val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true
    return false
  }
  return false
}

/**
 * 判断手机号码是否正确
 */
export function validPhone (phone) {
  // var isPhone = /^0\d{2,3}-?\d{7,8}$/
  // 增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  return reg.test(phone)
}



// WEBPACK FOOTER //
// ./src/utils/validate.js